import React, { PureComponent } from 'react'
import { string, number, bool, object, func, arrayOf, shape } from 'prop-types'
import { PostRaceCard } from 'components'
import './SectionCards.css'


export class SectionPostRaceCardsGroup extends PureComponent {
    static propTypes = {
        cards: arrayOf(shape({
            groupId: string.isRequired,
            type: string.isRequired,
            icon: string.isRequired,
            name: string.isRequired,
            deterioration: number,
            bullets: arrayOf(string).isRequired,
            options: arrayOf(shape({
                typeId: string.isRequired,
                label: string.isRequired,
                price: number.isRequired
            })).isRequired,
        })).isRequired,
        availableCredits: number.isRequired,
        selection: object.isRequired,
        onSetOption: func.isRequired,
        isAMToolActive: bool.isRequired,
        curvesParams: shape({
            engine: object.isRequired,
            gearbox: object.isRequired,
            wheels: object.isRequired
        }).isRequired
    }

    state = {
        selectedGroupId: null
    }

    handleSelect = id => this.setState({ selectedGroupId: id === this.state.selectedGroupId ? null : id })

    renderCard = ({ groupId, type, icon, name, deterioration, bullets, options }) => {
        const { availableCredits, selection, onSetOption, isAMToolActive, curvesParams } = this.props
        const { selectedGroupId } = this.state
        const isSelected = selectedGroupId === groupId
        return (
            <PostRaceCard
                key={groupId}
                groupId={groupId}
                icon={icon}
                name={name}
                deterioration={deterioration}
                bullets={bullets}
                options={options}
                selected={isSelected}
                selection={selection[selectedGroupId]}
                availableCredits={availableCredits}
                onSelect={this.handleSelect}
                onSetOption={onSetOption}
                isAMToolActive={isAMToolActive}
                curveParams={curvesParams[type]}
            />
        )
    }

    render() {
        const { cards } = this.props
        return (
            <section className="Cards PostRaceCards flex row-stretch-top">
                {cards.map(this.renderCard)}
            </section>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Sections/Cards/SectionPostRaceCardsGroup.js